import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/user/line_back_ico_l.png'
import _imports_1 from '@/assets/user/c_arrow_w_l.png'
import _imports_2 from '@/assets/user/c_arrow_w_r.png'


const _hoisted_1 = { class: "layer" }
const _hoisted_2 = { class: "wrap" }
const _hoisted_3 = { class: "content" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "BACK", -1)
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "page_title" }, "체중/체성분 상세 데이터", -1)
const _hoisted_8 = { class: "graph_box" }
const _hoisted_9 = { class: "graph_date_box" }
const _hoisted_10 = { type: "button" }
const _hoisted_11 = { type: "button" }
const _hoisted_12 = { class: "data_detail_wrap" }
const _hoisted_13 = { class: "bc_wrap" }
const _hoisted_14 = { class: "bc_title_box" }
const _hoisted_15 = { class: "unit" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "updown_txt up" }, null, -1)
const _hoisted_17 = { class: "bc_graph_box" }
const _hoisted_18 = { class: "row" }
const _hoisted_19 = { class: "normal" }
const _hoisted_20 = { class: "hight" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "bc_unit_box" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("span", null, "54"),
    /*#__PURE__*/_createElementVNode("span", null, "73")
  ])
], -1)
const _hoisted_22 = { class: "bc_wrap" }
const _hoisted_23 = { class: "bc_title_box" }
const _hoisted_24 = { class: "unit" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "updown_txt up" }, null, -1)
const _hoisted_26 = { class: "bc_graph_box" }
const _hoisted_27 = { class: "row" }
const _hoisted_28 = { class: "normal" }
const _hoisted_29 = { class: "hight" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "bc_unit_box" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("span", null, "34.9"),
    /*#__PURE__*/_createElementVNode("span", null, "41.3")
  ])
], -1)
const _hoisted_31 = { class: "bc_wrap" }
const _hoisted_32 = { class: "bc_title_box" }
const _hoisted_33 = { class: "unit" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", { class: "updown_txt up" }, null, -1)
const _hoisted_35 = { class: "bc_graph_box" }
const _hoisted_36 = { class: "row" }
const _hoisted_37 = { class: "normal" }
const _hoisted_38 = { class: "hight" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "bc_unit_box" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("span", null, "28.6"),
    /*#__PURE__*/_createElementVNode("span", null, "34.9")
  ])
], -1)
const _hoisted_40 = { class: "bc_wrap" }
const _hoisted_41 = { class: "bc_title_box" }
const _hoisted_42 = { class: "unit" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("span", { class: "updown_txt up" }, null, -1)
const _hoisted_44 = { class: "bc_graph_box" }
const _hoisted_45 = { class: "row" }
const _hoisted_46 = { class: "normal" }
const _hoisted_47 = { class: "hight" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", { class: "bc_unit_box" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("span", null, "28.6"),
    /*#__PURE__*/_createElementVNode("span", null, "34.9")
  ])
], -1)
const _hoisted_49 = { class: "bc_wrap" }
const _hoisted_50 = { class: "bc_title_box" }
const _hoisted_51 = { class: "unit" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("span", { class: "updown_txt down" }, null, -1)
const _hoisted_53 = { class: "bc_graph_box" }
const _hoisted_54 = { class: "row" }
const _hoisted_55 = { class: "normal" }
const _hoisted_56 = { class: "hight" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("div", { class: "bc_unit_box" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("span", null, "28.6"),
    /*#__PURE__*/_createElementVNode("span", null, "34.9")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderLayout = _resolveComponent("HeaderLayout")!
  const _component_Chart = _resolveComponent("Chart")!
  const _component_GnbLayout = _resolveComponent("GnbLayout")!
  const _component_ModalComponent = _resolveComponent("ModalComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_HeaderLayout),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            type: "button",
            class: "in_back_btn",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.backList && $setup.backList(...args)))
          }, _hoisted_6),
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_Chart, {
              titlePadding: $setup.state.titlePadding,
              data: $setup.state.chartList,
              legendPosition: $setup.state.legendPosition,
              width: $setup.state.chartWidth,
              height: $setup.state.chartHeight,
              title: $setup.state.title,
              subTitle: $setup.state.subTitle
            }, null, 8, ["titlePadding", "data", "legendPosition", "width", "height", "title", "subTitle"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("button", _hoisted_10, [
              _createElementVNode("img", {
                src: _imports_1,
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.prevDate && $setup.prevDate(...args)))
              })
            ]),
            _createElementVNode("span", null, _toDisplayString($setup.dateFormat($setup.health.date)), 1),
            _createElementVNode("button", _hoisted_11, [
              _createElementVNode("img", {
                src: _imports_2,
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.nextDate && $setup.nextDate(...args)))
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("span", _hoisted_15, [
                  _createTextVNode("체중 "),
                  _createElementVNode("b", null, _toDisplayString($setup.health.weight), 1),
                  _createTextVNode("kg")
                ]),
                _hoisted_16
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("p", _hoisted_18, [
                  _createElementVNode("span", {
                    style: _normalizeStyle({ width: $setup.calculateWidth($setup.health.weight, 0, 54) + '%' })
                  }, null, 4)
                ]),
                _createElementVNode("p", _hoisted_19, [
                  _createElementVNode("span", {
                    style: _normalizeStyle({ width: $setup.calculateWidth($setup.health.weight, 54, 73) + '%' })
                  }, null, 4)
                ]),
                _createElementVNode("p", _hoisted_20, [
                  _createElementVNode("span", {
                    style: _normalizeStyle({ width: $setup.calculateWidth($setup.health.weight, 73, 110) + '%' })
                  }, null, 4)
                ])
              ]),
              _hoisted_21
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("span", _hoisted_24, [
                  _createTextVNode("체수분량 "),
                  _createElementVNode("b", null, _toDisplayString($setup.health.totalBodyWater.toFixed(1)), 1),
                  _createTextVNode("kg")
                ]),
                _hoisted_25
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("p", _hoisted_27, [
                  _createElementVNode("span", {
                    style: _normalizeStyle({ width: $setup.calculateWidth($setup.health.totalBodyWater, 0, 34.9) + '%' })
                  }, null, 4)
                ]),
                _createElementVNode("p", _hoisted_28, [
                  _createElementVNode("span", {
                    style: _normalizeStyle({ width: $setup.calculateWidth($setup.health.totalBodyWater, 34.9, 41.3) + '%' })
                  }, null, 4)
                ]),
                _createElementVNode("p", _hoisted_29, [
                  _createElementVNode("span", {
                    style: _normalizeStyle({ width: $setup.calculateWidth($setup.health.totalBodyWater, 41.3, 60) + '%' })
                  }, null, 4)
                ])
              ]),
              _hoisted_30
            ]),
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("span", _hoisted_33, [
                  _createTextVNode("골격근량 "),
                  _createElementVNode("b", null, _toDisplayString($setup.health.muscleMass.toFixed(1)), 1),
                  _createTextVNode("kg")
                ]),
                _hoisted_34
              ]),
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("p", _hoisted_36, [
                  _createElementVNode("span", {
                    style: _normalizeStyle({ width: $setup.calculateWidth($setup.health.muscleMass, 0, 28.6) + '%' })
                  }, null, 4)
                ]),
                _createElementVNode("p", _hoisted_37, [
                  _createElementVNode("span", {
                    style: _normalizeStyle({ width: $setup.calculateWidth($setup.health.muscleMass, 28.6, 34.9) + '%' })
                  }, null, 4)
                ]),
                _createElementVNode("p", _hoisted_38, [
                  _createElementVNode("span", {
                    style: _normalizeStyle({ width: $setup.calculateWidth($setup.health.muscleMass, 34.9, 80) + '%' })
                  }, null, 4)
                ])
              ]),
              _hoisted_39
            ]),
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("span", _hoisted_42, [
                  _createTextVNode("BMI "),
                  _createElementVNode("b", null, _toDisplayString($setup.health.bmi.toFixed(1)), 1)
                ]),
                _hoisted_43
              ]),
              _createElementVNode("div", _hoisted_44, [
                _createElementVNode("p", _hoisted_45, [
                  _createElementVNode("span", {
                    style: _normalizeStyle({ width: $setup.calculateWidth($setup.health.bmi, 0, 28.6) + '%' })
                  }, null, 4)
                ]),
                _createElementVNode("p", _hoisted_46, [
                  _createElementVNode("span", {
                    style: _normalizeStyle({ width: $setup.calculateWidth($setup.health.bmi, 28.6, 34.9) + '%' })
                  }, null, 4)
                ]),
                _createElementVNode("p", _hoisted_47, [
                  _createElementVNode("span", {
                    style: _normalizeStyle({ width: $setup.calculateWidth($setup.health.bmi, 34.9, 80) + '%' })
                  }, null, 4)
                ])
              ]),
              _hoisted_48
            ]),
            _createElementVNode("div", _hoisted_49, [
              _createElementVNode("div", _hoisted_50, [
                _createElementVNode("span", _hoisted_51, [
                  _createTextVNode("체지방률 "),
                  _createElementVNode("b", null, _toDisplayString($setup.health.fatRatio.toFixed(1)), 1),
                  _createTextVNode("%")
                ]),
                _hoisted_52
              ]),
              _createElementVNode("div", _hoisted_53, [
                _createElementVNode("p", _hoisted_54, [
                  _createElementVNode("span", {
                    style: _normalizeStyle({ width: $setup.calculateWidth($setup.health.fatRatio, 0, 28.6) + '%' })
                  }, null, 4)
                ]),
                _createElementVNode("p", _hoisted_55, [
                  _createElementVNode("span", {
                    style: _normalizeStyle({ width: $setup.calculateWidth($setup.health.fatRatio, 28.6, 34.9) + '%' })
                  }, null, 4)
                ]),
                _createElementVNode("p", _hoisted_56, [
                  _createElementVNode("span", {
                    style: _normalizeStyle({ width: $setup.calculateWidth($setup.health.fatRatio, 34.9, 80) + '%' })
                  }, null, 4)
                ])
              ]),
              _hoisted_57
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_GnbLayout),
    _createVNode(_component_ModalComponent, {
      show: $setup.state.isModalOpen,
      yes: $setup.modal.confirm,
      no: $setup.modal.cancel,
      content: $setup.modal.content,
      onClose: $setup.modalClose
    }, null, 8, ["show", "yes", "no", "content", "onClose"])
  ], 64))
}